export const enSolutionsDropdown = {
  "saas_billing": {
    "title": "SaaS Billing System",
    "description": "Manage your subscriptions and billing with ease."
  },
  "HR_Management_system": {
    "title": "HR Management System",
    "description": "Streamline your HR processes and employee management."
  },
  "POS_System": {
    "title": "POS System",
    "description": "Manage your sales and inventory with our Point of Sale system."
  },
  "ride_sharing": {
    "title": "Taxi Solution/Platform",
    "description": "Connect drivers and passengers seamlessly."
  },
  "LMS_Marketplace": {
    "title": "Learning Management System Marketplace",
    "description": "Create and manage your online courses with our LMS platform."
  },
  "food_delivery": {
    "title": "Food Delivery Marketplace",
    "description": "Create your food delivery service with our ready-to-use platform."
  },
  "service_booking": {
    "title": "Service Booking Platform",
    "description": "Manage bookings and appointments efficiently."
  },
  "ecommerce_multi_vendor": {
    "title": "E-Commerce Multi-Vendor Marketplace",
    "description": "Create a thriving online marketplace with our multi-vendor solution."
  }
};

export const frSolutionsDropdown = {
  "saas_billing": {
    "title": "Système de Facturation SaaS",
    "description": "Gérez vos abonnements et votre facturation en toute simplicité."
  },
  "HR_Management_system": {
    "title": "Système de Gestion RH",
    "description": "Rationalisez vos processus RH et la gestion des employés."
  },
  "POS_System": {
    "title": "Système de Point de Vente",
    "description": "Gérez vos ventes et votre inventaire avec notre système de point de vente."
  },
  "ride_sharing": {
    "title": " Solution/Plateforme de Taxi",
    "description": "Connectez conducteurs et passagers en toute simplicité."
  },
  "LMS_Marketplace": {
    "title": "Marketplace de Système d'Apprentissage",
    "description": "Créez et gérez vos cours en ligne avec notre plateforme LMS."
  },
  "food_delivery": {
    "title": "Marketplace de Livraison de Nourriture",
    "description": "Créez votre service de livraison de nourriture avec notre plateforme prête à l'emploi."
  },
  "service_booking": {
    "title": "Plateforme de Réservation de Services",
    "description": "Gérez les réservations et les rendez-vous efficacement."
  },
  "ecommerce_multi_vendor": {
    "title": "Marketplace E-Commerce Multi-Vendeur",
    "description": "Créez une marketplace en ligne prospère avec notre solution multi-vendeur."
  }
};

export const nlSolutionsDropdown = {
  "saas_billing": {
    "title": "SaaS Facturatiesysteem",
    "description": "Beheer eenvoudig uw abonnementen en facturatie."
  },
  "HR_Management_system": {
    "title": "HR Management Systeem",
    "description": "Stroomlijn uw HR-processen en personeelsbeheer."
  },
  "POS_System": {
    "title": "POS Systeem",
    "description": "Beheer uw verkoop en voorraad met ons kassasysteem."
  },
  "ride_sharing": {
    "title": "Taxi Oplossing/Platform",
    "description": "Verbind chauffeurs en passagiers naadloos."
  },
  "LMS_Marketplace": {
    "title": "Leerbeheersysteem Marketplace",
    "description": "Maak en beheer uw online cursussen met ons LMS-platform."
  },
  "food_delivery": {
    "title": "Food Delivery Marktplaats",
    "description": "Start uw bezorgdienst met ons kant-en-klare platform."
  },
  "service_booking": {
    "title": "Serviceboekingsplatform",
    "description": "Beheer boekingen en afspraken efficiënt."
  },
  "ecommerce_multi_vendor": {
    "title": "E-Commerce Multi-Vendor Marktplaats",
    "description": "Creëer een bloeiende online marktplaats met onze multi-vendor oplossing."
  }
};

export const deSolutionsDropdown = {
  "saas_billing": {
    "title": "SaaS-Abrechnungssystem",
    "description": "Verwalten Sie Ihre Abonnements und Abrechnung ganz einfach."
  },
  "HR_Management_system": {
    "title": "Personalmanagementsystem",
    "description": "Optimieren Sie Ihre HR-Prozesse und Mitarbeiterverwaltung."
  },
  "POS_System": {
    "title": "Point-of-Sale-System",
    "description": "Verwalten Sie Ihre Verkäufe und Bestände mit unserem Kassensystem."
  },
  "ride_sharing": {
    "title": " Taxi Lösung/Plattform",
    "description": "Verbinden Sie Fahrer und Passagiere nahtlos."
  },
  "LMS_Marketplace": {
    "title": "Lernmanagementsystem-Marktplatz",
    "description": "Erstellen und verwalten Sie Ihre Online-Kurse mit unserer LMS-Plattform."
  },
  "food_delivery": {
    "title": "Food-Delivery-Marktplatz",
    "description": "Starten Sie Ihren Lieferservice mit unserer einsatzbereiten Plattform."
  },
  "service_booking": {
    "title": "Servicebuchungsplattform",
    "description": "Verwalten Sie Buchungen und Termine effizient."
  },
  "ecommerce_multi_vendor": {
    "title": "E-Commerce Multi-Vendor Marktplatz",
    "description": "Erstellen Sie einen florierenden Online-Marktplatz mit unserer Multi-Vendor-Lösung."
  }
};